import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ThemesService
{
   private currentThemeLink: HTMLLinkElement | null = null;

   setTheme(theme: 'admin' | 'web' | 'company-empower')
   {
      if (!this.currentThemeLink)
      {
         this.currentThemeLink = document.createElement('link');
         this.currentThemeLink.rel = 'stylesheet';
         this.currentThemeLink.id = 'app-theme';
         document.head.appendChild(this.currentThemeLink);
      }

      switch (theme)
      {
         case 'admin':
            this.currentThemeLink.href = 'admin-theme.css';
            break;
         case 'web':
            this.currentThemeLink.href = 'web-theme.css';
            break;
         case 'company-empower':
            this.currentThemeLink.href = 'company-empower-theme.css';
            break;
      }
   }
}